<div class="container mt-5" style="max-width: 400px;">
  <h3 class="mb-4 login" >SmartEHR Coder 登入</h3>

  <div *ngIf="errorMsg" class="alert alert-danger">
    {{ errorMsg }}
  </div>

  <form (ngSubmit)="login()">
    <div class="mb-3 login">
      <label for="account" class="form-label">帳號</label>
      <input
        id="account"
        name="account"
        class="form-control"
        [(ngModel)]="account"
        required
      />
    </div>

    <div class="mb-3 login">
      <label for="password" class="form-label">密碼</label>
      <div class="input-group">
        <input
          id="password"
          name="password"
          [type]="showPassword ? 'text' : 'password'"
          class="form-control"
          [(ngModel)]="password"
          required
        />
        <button
        class="btn btn-outline-secondary border-start-0"
        type="button"
        class="eye-btn"
        (click)="toggleShowPassword()"
        [attr.aria-label]="showPassword ? '隱藏密碼' : '顯示密碼'"
        >
          <img
            [src]="showPassword ? 'assets/images/open-eye.svg' : 'assets/images/close-eye.svg'"
            alt="Toggle password visibility"
            class="eye-icon"
          />
        </button>
      </div>
    </div>

    <button type="submit" class="btn btn-primary w-100">登入</button>
  </form>
</div>
<!--footer-->
<div id="footer">
  <div class="login-logos">
    <img src="../../../assets/images/mohw_logo.png" class="logomark" alt="" />
    <img src="../../../assets/images/itri_logo.png" class="logomark" alt="" />
  </div>
</div>
<!--content end-->